import * as zod from 'zod';

export const Robotiq2FControlKind = zod.enum(['move']);

export const Robotiq2FCommand = zod.object({
  kind: zod.literal('Robotiq2FCommand'),
  controlKind: Robotiq2FControlKind,
  targetGripWidth: zod.number().nonnegative(),
  targetSpeed: zod.number().nonnegative(),
  targetForce: zod.number().nonnegative(),
  /**
   * When set, a closing actuation must end with the jaws stopped on a part at
   * `targetGripWidth` (within `targetDiameterTolerance`) or it is reported as a
   * failed grip. Omitted by jog/stream callers, which never grip.
   */
  waitForGripToContinue: zod.boolean().optional(),
  /** How far (meters) the achieved grip width may sit from the target. */
  targetDiameterTolerance: zod.number().nonnegative().optional(),
});

export type Robotiq2FCommand = zod.infer<typeof Robotiq2FCommand>;
